<template>
  <div id="Jan2024" class="202401 relative">

    <div class="banner w-full mb-1 xl:mb-12">
      <div class="sm:hidden"><img src="~@/assets/images/202403/banner_m.png" class="object-contain block mx-auto"></div>
      <div class="hidden sm:block"><img src="~@/assets/images/202403/main.png" class="object-contain block"></div>
      <div class="hidden sm:block container -mt-24 xl:-mt-48 px-48 xl:px-64"><img src="~@/assets/images/202403/main-info.png" class="object-contain block"></div>
    </div>

    <section class="main container p-4 hidden sm:block">
      <div class="plan1 pl-24 md:pl-32 xl:pl-48 pr-6 md:pr-16 pt-24 lg:pt-32 xl:pt-28 pb-20 mb-6">
        <div class="flex items-center border-b-2 border-dotted border-gray-500 xl:px-10">
          <div class="w-2/3 p-4">
            <div class="lg:px-20"><img src="~@/assets/images/202403/sch1-gift1-info.png" class="object-contain block"></div>
            <p class="text-lg font-semibold"><img src="~@/assets/images/202403/arrow.png" class="object-contain inline-block w-12">贈品數量有限，送完為止，若贈送完畢，得以等值贈品替換。</p>
          </div>
          <div class="w-1/3 p-4"><img src="~@/assets/images/202403/sch1-gift1-img.png" class="object-contain block"></div>
        </div>
        <div class="flex items-center flex-wrap">
          <div class="w-1/3"><img src="~@/assets/images/202403/sch1-gift2-img.png" class="object-contain block"></div>
          <div class="w-2/3 p-4">
            <div class="lg:px-20"><img src="~@/assets/images/202403/sch1-gift2-info.png" class="object-contain block"></div>
          </div>
          <div class="w-fill">
            <p class="font-semibold"><img src="~@/assets/images/202403/arrow.png" class="object-contain inline-block w-12">其票券為LiveABC向Ticket Xpress即享券企業禮贈平台購買之「7-ELEVEN數位商品禮券$100元」，將於2024.4.30前統一以簡訊方式寄出。</p>
            <p class="font-semibold"><img src="~@/assets/images/202403/arrow.png" class="object-contain inline-block w-12">本券適用通路 : 統一超商、COSMED康是美、統一時代百貨、高雄夢時代購物中心、BEING spa、統一健身俱樂部、悠旅生活事業(星巴克)、速邁樂加油中心、統一多拿滋、21風味館、酷聖石冰淇淋、Semeur聖娜、聖德科斯、統一渡假村。</p>
            <p class="font-semibold"><img src="~@/assets/images/202403/arrow.png" class="object-contain inline-block w-12">此電子券無使用期限</p>
          </div>
        </div>
      </div>
      <div class="plan2 mb-6">
        <div class="title-bg mb-3 py-16 xl:pt-24 xl:pb-24 px-12">
          <img src="~@/assets/images/202403/sch2-title.png" class="object-contain block w-2/3 mx-auto">
        </div>
        <div class="inner bg-white p-4">
          <div class="flex border-b-2 border-dotted border-gray-500 pb-3">
            <div class="flex flex-wrap w-3/5">
              <a target="_blank" class="w-1/2 md:w-1/3 p-2" v-for="(item, index) in magData" :key="index">
                <img :src="item.img_url" class="object-contain block">
              </a>
              <div class="w-1/2 md:w-1/3 p-2 flex items-center justify-center"><img src="~@/assets/images/202403/plus.png" class="w-16 object-contain block"></div>
            </div>
            <div class="w-2/5"><img src="~@/assets/images/202403/livepen.png" class="object-contain block -ml-12"></div>
          </div>
          <div class="flex flex-wrap items-center justify-center pt-3">
            <div class="w-full md:w-3/5 px-4"><img src="~@/assets/images/202403/sch2-info.png" class="object-contain block"></div>
            <a class="w-full md:w-2/5 px-16 md:px-10 xl:px-16 lg:w-1/3" target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=347"><img src="~@/assets/images/202403/bt-shopping.png" class="object-contain block"></a>
          </div>
        </div>
      </div>
      <div class="plan3 mb-6">
        <div class="title-bg mb-3 py-16 xl:pt-24 xl:pb-16 px-12">
          <img src="~@/assets/images/202403/sch3-title.png" class="object-contain block w-2/3 mx-auto">
        </div>
        <div class="inner bg-white pt-12 px-6 md:px-12">
          <div class="flex flex-wrap">
            <div class="w-1/3 border-b-2 border-dotted border-gray-500 pb-3"><img src="~@/assets/images/202403/mg-hiw.png" class="object-contain block"></div>
            <div class="w-2/3 border-b-2 border-dotted border-gray-500 pb-3">
              <div><img src="~@/assets/images/202403/sch3-info.png" class="object-contain block"></div>
              <div><img src="~@/assets/images/202403/sch3-sub.png" class="object-contain block"></div>
            </div>
            <div class="flex flex-wrap w-full pt-3">
              <a target="_blank" class="w-1/2 md:w-1/5 p-2" v-for="(item, index) in magData" :key="index">
                <img :src="item.img_url" class="object-contain block">
              </a>
            </div>
            <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=331" class="w-full flex justify-center px-16 md:px-10 xl:px-16">
              <img src="~@/assets/images/202403/bt-sub.png" class="object-contain block lg:w-1/3"></a>
          </div>
        </div>
      </div>
      <div class="plan4 pl-24 md:pl-32 xl:pl-48 pr-6 md:pr-16 pt-24 lg:pt-32 xl:pt-28 pb-20 mb-6">
        <div class="flex items-center flex-wrap border-b-2 border-dotted border-gray-500 xl:px-10">
          <div class="w-full"><img src="~@/assets/images/202403/sch4-title.png" class="object-contain block"></div>
          <div class="w-1/3 p-4"><img src="~@/assets/images/202403/livepen.png" class="object-contain block"></div>
          <div class="w-2/3 p-4">
            <div class=""><img src="~@/assets/images/202403/sch4-info.png" class="object-contain block"></div>
          </div>
        </div>

        <div class="w-full lg:px-48 py-6"><img src="~@/assets/images/202403/sch4-gift-title.png" class="object-contain block"></div>

        <div>
          <img src="~@/assets/images/202403/sch4-gift-img.png" class="object-contain block">
        </div>
        <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=332" class="w-full flex justify-center px-16 md:px-10 xl:px-16">
          <img src="~@/assets/images/202403/bt-shopping.png" class="object-contain block lg:w-1/3"></a>
      </div>
      <div class="plan5">
        <div class="title-bg mb-3 py-16 xl:pt-24 xl:pb-2 px-12">
          <img src="~@/assets/images/202403/sch5-title.png" class="object-contain block w-2/3 mx-auto">
        </div>
        <div class="inner bg-white pt-12 px-6 md:px-12">
          <div class="mb-6"><img src="~@/assets/images/202403/sch5-img.png" class="object-contain block"></div>
          <a href="https://livejapanese.liveabc.com/login" target="_blank" class="flex pb-4">
            <div class="p-6"><img src="~@/assets/images/202403/sch5-info.png" class="object-contain block"></div>
            <div class="p-4"><img src="~@/assets/images/202403/sch5-gift.png" class="object-contain block"></div>
          </a>
          <div class="border-t-2 border-dotted border-gray-500 py-6"><img src="~@/assets/images/202403/sch5-intro-web.png" class="object-contain block"></div>
          <a href="https://livejapanese.liveabc.com/login" target="_blank" class="flex border-t-2 border-dotted border-gray-500 py-8">
            <div class=""><img src="~@/assets/images/202403/sch5-intro-mg1.png" class="object-contain block"></div>
            <div class=""><img src="~@/assets/images/202403/sch5-intro-mg2.png" class="object-contain block"></div>
          </a>
          <a target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=333" class="w-full flex justify-center px-16 md:px-10 xl:px-16">
            <img src="~@/assets/images/202403/bt-shopping.png" class="object-contain block lg:w-1/3">
          </a>
        </div>
      </div>
    </section>
    <section class="main-mobile container sm:hidden p-4">
      <div class="plan1">
        <img src="~@/assets/images/202403/mobi_P2.png" class="object-contain block">
      </div>
      <a class="plan2" target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=347">
        <img src="~@/assets/images/202403/mobi_P3.png" class="object-contain block">
      </a>
      <a class="plan3" target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=331">
        <img src="~@/assets/images/202403/mobi_P4.png" class="object-contain block">
      </a>
      <a class="plan4" target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=332">
        <img src="~@/assets/images/202403/mobi_P5.png" class="object-contain block">
      </a>
      <a class="plan5" target="_blank" href="https://store.liveabc.com/products/magazine/sale?tag=333">
        <img src="~@/assets/images/202403/mobi_P6.png" class="object-contain block">
      </a>
    </section>

    <section class="footer md:py-16">
      <div class="container py-6 px-8 md:px-32 lg:px-48 xl:px-32 text-white green-bg relative">
        <div class="mb-3"><img src="~@/assets/images/202403/note.png" class="object-contain block mx-auto h-12"></div>

        <ul class="list-outside list-disc text-sm md:text-base leading-loose">
          <li >凡於活動時間2024.2.16~3.31內，於LiveABC官網購物，單筆滿額1,000元贈送【手繪英語極短句 (口袋書)】；滿額2,500元再加送【7-ELEVEN數位商品禮券100元】。</li>
          <li >【7-ELEVEN數位商品禮券100元】之票券為LiveABC向Ticket Xpress即享券企業禮贈平台所以購買，將於2024.4.30前統一以簡訊方式寄出。本券適用於統一超商、COSMED康是美、統一時代百貨、高雄夢時代購物中心、BEING spa、統一健身俱樂部、悠旅生活事業(星巴克)、速邁樂加油中心、統一多拿滋、21風味館、酷聖石冰淇淋、Semeur聖娜、聖德科斯、統一渡假村。此電子券無使用期限。</li>
          <li >贈品數量有限，送完為止，若贈送完畢，得以等值贈品替換。</li>
          <li >活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</li>
        </ul>
        <div class="flex justify-between">
          <div class="left md:absolute"><img src="~@/assets/images/202403/note-img1.png" class="object-contain block mx-auto"></div>
          <div class="right md:absolute"><img src="~@/assets/images/202403/note-img2.png" class="object-contain block mx-auto"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Mar2024',
  metaInfo () {
    return {
      title: '2024春季開學書展 LiveABC開學好禮1+1 2024.2.16~3.31',
      titleTemplate: null
    }
  },
  data () {
    return {
      renderComponent: false,
      isMenu: true,
      magData: [
        { id: 7694, img_url: require('@/assets/images/202403/mg-abc.png') },
        { id: 7549, img_url: require('@/assets/images/202403/mg-live.png') },
        { id: 7494, img_url: require('@/assets/images/202403/mg-all.png') },
        { id: 8286, img_url: require('@/assets/images/202403/mg-cnn.png') },
        { id: 8134, img_url: require('@/assets/images/202403/mg-jp.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
#Jan2024 {
  .container {
    max-width: 1200px !important;
  }
  background-color: #FFEAB1;
  .banner {

  }
  .main {
  .title-bg {
    background-image: url('~@/assets/images/202403/title-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: top;
  }
    .plan1 {
      background-image: url('~@/assets/images/202403/sch1-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
    .plan4 {
      background-image: url('~@/assets/images/202403/sch1-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  .footer {
    ul {
      @media (max-width: 767px) {
        line-height: 32px !important;
      }
    }
    .green-bg {
      background: #6EC9BA;
    }
    .left {
      left: -10%;
      bottom: 0;
      width: 20%;
      @media (max-width: 767px) {
        left: 0%;
        width: auto;
      }
    }
    .right {
      right: -10%;
      bottom: 0;
      width: 20%;
      @media (max-width: 767px) {
        right: 0%;
        width: auto;
      }
    }
  }
}
</style>
